import { isEmpty } from 'lodash';
import React from 'react';

import Paragraph from 'pages/Landings/components/Paragraph';
import formatDate from 'utils/format-date';

import useStyles from './styles';

interface Props {
    title: string;
    description: string;
    published: Date;
    timeToRead: string;
    tags: string[];
    link: string;
    className?: string;
}

const PostCard: React.FC<Props> = ({ link, title, description, published, timeToRead, tags, className }) => {
    const { classes, cx } = useStyles();

    return (
        <a href={link} target="_blank" className={cx(classes.root, className)} rel="noreferrer noopener">
            <span className={classes.published}>
                {formatDate(published, 'MMM d')}&nbsp;•&nbsp;{timeToRead}
            </span>
            <Paragraph primary={title} secondary={description} />
            {isEmpty(tags) ? null : (
                <div className={classes.tags}>
                    {tags.map((tag, index) => (
                        <span key={index} className={classes.tag}>
                            {tag}
                        </span>
                    ))}
                </div>
            )}
        </a>
    );
};

export default PostCard;
